import React from 'react'

export const IconArrow: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g transform="matrix(0.00017173,1,-1,0.00017173,24.8513,-0.855561)">
        <path d="M10.707 17.707L16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
      </g>
    </svg>
  )
}
